import React, { useCallback, useMemo } from "react";
import AlertContainer from "./AlertContainer";
import useAccountMessagesStore from "@/stores/useAccountMessagesStore";

interface MyPagesNotificationsProps {
  menuLinks: any;
  setCurrentPage: any;
}

const AlertMemomized = React.memo(
  ({ notification, matchOnEndpoint, onClick }: any) => (
    <AlertContainer
      onClick={onClick}
      notification={notification}
      matchOnEndpoint={matchOnEndpoint}
    />
  )
);

AlertMemomized.displayName = "AlertMemomized";

const MyPagesNotifications: React.FC<MyPagesNotificationsProps> = ({
  menuLinks,
  setCurrentPage,
}) => {
  const { accountMessages } = useAccountMessagesStore();

  const notificationsFiltered = useMemo(
    () =>
      accountMessages &&
      accountMessages?.filter(
        (n: any) => n.sticky && (!n.read || !n.isDismissable)
      ),
    [accountMessages]
  );

  const maybeNavigateToEndpoint = useCallback(
    (endpoint: any) => {
      if (!endpoint) {
        return false;
      }

      setCurrentPage(endpoint.slug);
    },
    [setCurrentPage]
  );

  if (!notificationsFiltered?.length) return null;

  return (
    <div className="mb-8 flex flex-col space-y-6 md:my-6">
      {notificationsFiltered &&
        notificationsFiltered?.map((notification: any, index: any) => {
          const matchOnEndpoint = menuLinks.find(
            (e: any) => e.identifier === notification.type
          );

          return (
            <AlertMemomized
              onClick={() => maybeNavigateToEndpoint(matchOnEndpoint)}
              key={notification.id}
              notification={notification}
              matchOnEndpoint={matchOnEndpoint}
            />
          );
        })}
    </div>
  );
};

export default MyPagesNotifications;
